<script setup lang="ts">
import { ref, onMounted, computed, onBeforeUnmount, watch } from "vue";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";

const props = defineProps<{ enhancementTier: string }>();

const contents = computed(() => {
  if (props.enhancementTier === "full_enhancements") {
    return {
      caption: "Hang tight — we're making your design PrintPerfect",
      highlights: [
        "Enhancing resolution",
        "Boosting vibrancy",
        "Refining edges",
        "Cropping unwanted areas",
        "Removing background perfectly"
      ]
    };
  }

  return {
    caption: "Processing...",
    highlights: []
  };
});

const currentIndex = ref(0);
let intervalId;

watch(
  () => props.enhancementTier,
  () => {
    currentIndex.value = 0;
  }
);

onMounted(() => {
  intervalId = setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % contents.value.highlights.length;
  }, 3000);
});

onBeforeUnmount(() => {
  clearInterval(intervalId);
});
</script>

<template>
  <div class="z-2 absolute left-1/2 top-1/2 w-[300px] -translate-x-1/2 -translate-y-1/2 p-2">
    <div
      class="flex flex-row items-center justify-center gap-4 rounded-lg bg-white p-4 shadow-lg lg:flex-col"
    >
      <span class="flex h-7 w-7 items-center justify-center lg:h-11 lg:w-11">
        <UseSvg class="size-7 text-pink-500 lg:size-11" icon="stars-corners" />
      </span>
      <div class="flex flex-col items-center gap-1 text-sm lg:gap-4 lg:text-base">
        <div class="text-center">
          <div class="font-bold text-gray-700">
            {{ contents.caption }}
          </div>
        </div>
        <div v-if="contents.highlights.length > 0" class="flex flex-col items-center gap-1">
          <div class="text-center text-gray-600">
            <transition name="fade" mode="out-in">
              <span :key="currentIndex">
                {{ contents.highlights[currentIndex] }}
              </span>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
